/**
 * TODO: this could be moved to pro-gallery-lib for universal use
 * @returns {Handle} - a pipeable object that allows to register event handlers, to close the pipe use the done method
 * @example
 * const eventListener = makeEventListener();
 * eventListener
 *  .HOVER_SET<{ idx: number }>(({idx}) => console.log('hovering on item', idx))
 *  .done();
 */

export function makeEventListener() {
  const handlers = {};
  const handler = (event, data) => {
    const eventHandlers = handlers[event];
    if (eventHandlers) {
      eventHandlers.forEach(_handler => _handler(data));
    }
  };
  const self = new Proxy({}, {
    get: (_, prop) => {
      if (prop === 'done') {
        return parent => (eventName, data) => {
          handler(eventName, data);
          if (parent) {
            parent(eventName, data);
          }
        };
      }
      return handlerToAdd => {
        const event = prop;
        if (!handlers[event]) {
          handlers[event] = [];
        }
        handlers[event].push(handlerToAdd);
        return self;
      };
    }
  });
  return self;
}
//# sourceMappingURL=eventListener.js.map